module.exports = __webpack_public_path__ + "static/media/Qerkk_preview.855ea2ac.jpg";